import { getDatabase, ref, child } from "firebase/database";
import { getAuth } from "firebase/auth";

// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";


/* test db */
// const firebaseConfig = {
//     apiKey: "AIzaSyC1DSDVJqMtcnZX2lgT4XrOFkJfyDD3Fzg",
//     authDomain: "okka01-67385.firebaseapp.com",
//     databaseURL: "https://okka01-67385-default-rtdb.europe-west1.firebasedatabase.app",
//     projectId: "okka01-67385",
//     storageBucket: "okka01-67385.appspot.com",
//     messagingSenderId: "685903410487",
//     appId: "1:685903410487:web:b18d88fe68845815a796b2"
//   };

/* live db */
const firebaseConfig = {
  apiKey: "AIzaSyBNb8HzdjUMgipX1Bs7siKwC9NES2aXyNo",
  authDomain: "ftc-machines-dev.firebaseapp.com",
  databaseURL: "https://ftc-machines-dev-default-rtdb.europe-west1.firebasedatabase.app/",
  projectId: "ftc-machines-dev",
  storageBucket: "ftc-machines-dev.appspot.com",
  messagingSenderId: "918366791343",
  appId: "1:918366791343:web:d27547c9f6cd97f046965a",
  measurementId: "G-25PYRFTPM7"
};
// Initialize Firebase
export const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);


export let locations = []
export const db = getDatabase(app)
export const dbRef = child(ref(db), `locations/`);
export const dbRefDevice = child(ref(db), `devices/`);
export const dbRefAdmins = child(ref(db), `admins/`);
export const dbRefTech = child(ref(db), `technicians/`);
export const dbRefUser = child(ref(db), `users/`);